export type ContiguousGroup<T> = {
  label: string;
  items: T[];
};

// Groups consecutive runs only: the same label reappearing after a different
// one starts a new group. Callers pass pre-sorted input when they want one
// group per label.
export const groupContiguousBy = <T>(
  items: readonly T[],
  getLabel: (item: T) => string,
): ContiguousGroup<T>[] =>
  items.reduce<ContiguousGroup<T>[]>((groups, item) => {
    const label = getLabel(item);
    const lastGroup = groups.at(-1);
    if (lastGroup?.label === label) {
      lastGroup.items.push(item);
    } else {
      groups.push({ label, items: [item] });
    }
    return groups;
  }, []);
